module.exports = __webpack_public_path__ + "img/Anett Rolikova.8b786d1f.jpg";